import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IActionInfo } from '@common/action-interfaces';
import { action_ids, eActionType } from '@common/actions/action-types';
import { String } from '@common/string-extensions';
import { ActionVersionFactory, EActionsVersions } from '@common/actions/actions-version';
import { ActionVersion0 } from '@common/actions/action-version-implementation/action-0';
import { ActionVersionBase } from '@common/actions/action-version-implementation';

@Injectable({
    providedIn: 'root'
})
export class ActionService
{
    constructor(
        private translate: TranslateService
    )
    { }

    public async prepareAction(type: eActionType, ...args: string[]): Promise<IActionInfo>
    {
        let action;
        action = ActionVersionFactory.getActionByVersion(EActionsVersions.VERSION_0, type, this.translate) as ActionVersion0;

        // todo need to remove this condition when "eActionType.SignMessage" action will be supported in HID
        if (type === eActionType.SignMessage)
        {
            action = ActionVersionFactory.getActionByVersion(EActionsVersions.VERSION_BASE, type, this.translate) as ActionVersionBase;
        }

        const info = action.getPreparedAction();

        if (info.action_id)
        {
            info.action_id = String.Format(info.action_id, ...args) as action_ids;
        }

        if (info.values)
        {
            info.values = await action.extractActionValues(info, ...args);
        }

        console.log(` == prepareAction == `);
        console.log(info);
        return info as IActionInfo;
    }
}
